const cachedAppLoadHashValue = '#cachedAppLoad';

export const addCachedAppLoadHashToUrl = (url: string) => url.split('#')[0] + cachedAppLoadHashValue;
export const removeCachedAppLoadHashFromUrl = (url: string) => url.split('#')[0];
export const isCachedAppPageLoadUrlHashPresent = () => location.hash === cachedAppLoadHashValue;
